import type { ReactNode } from "react";

interface SectionProps {
  children?: ReactNode;
  variant?: "white" | "gray1" | "gray2" | "blue" | "dark" | "transparent";
  className?: string;
  containerClassName?: string;
  id?: string;
}

export default function Section({
  children,
  variant = "white",
  className = "",
  containerClassName = "",
  id,
}: SectionProps) {
  const variants = {
    white: "bg-white text-foreground",
    gray1: "bg-gray-100 text-foreground",
    gray2: "bg-gray-200 text-foreground",
    blue: "bg-blue-50 text-foreground",
    dark: "bg-[#194172] text-white",
    transparent: "bg-transparent text-foreground", // ← neu
  };

  return (
    <section
      id={id}
      className={`py-16 sm:py-20 ${variants[variant]} ${className}`}
    >
      <div className={`mx-auto w-full max-w-7xl px-6 ${containerClassName}`}>
        {children}
      </div>
    </section>
  );
}
